import React, { useEffect, useState, useRef } from "react";
import ChatName from "../../component/support-chat/chatname";
import Inbox from "../../component/support-chat/inbox";
import ImageTag from "../../component/reusebale/imageTag";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { useDispatch, useSelector } from "react-redux";
import * as AuthAction from "../../store/actions/auth/AuthAction";
import * as DataAction from "../../store/actions/data/DataAction";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );
  // State to toggle dropdown
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Function to toggle menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Initialize state from localStorage if needed
  useEffect(() => {
    const initializeDashboard = async () => {
      // If no login success in redux state, try to hydrate from localStorage
      if (!loginSuccess) {
        if (AuthAction.hasValidLoginCredentials()) {
          // Hydrate state from localStorage
          const hydratedLoginData = await dispatch(
            AuthAction.HydrateStateAction()
          );

          // Fetch current shift and other necessary data
          if (
            hydratedLoginData?.user?._id &&
            hydratedLoginData?.user?.allowLogin
          ) {
            dispatch(
              DataAction.GetCurrentShiftAction(
                hydratedLoginData.user._id,
                hydratedLoginData
              )
            );
          }
        } else {
          // No valid credentials, redirect to login
          navigate("/login");
        }
      }
    };

    initializeDashboard();
  }, [dispatch, navigate, loginSuccess]);

  const { selectedSessionId, selectedCompletedSessionId } = useSelector(
    (state) => state.data
  );

  return (
    <div className="flex flex-col w-[98%] mx-auto h-screen">
      <div className="h-[15%] flex items-center">
        <div className="w-[25%] flex justify-center">
          <ImageTag
            path="/assets/logo.png"
            classes="w-[200px] object-cover"
            altText="logo"
          />
        </div>
        <div className="w-[75%]">
          <div
            className="flex justify-end items-center relative"
            ref={dropdownRef}
          >
            <div>
              <p className="font-popinsMedium text-xs text-darkColor/60">
                Welcome
              </p>
              <p className="font-popinsSemiBold text-base text-darkColor">
                {`${loginSuccess?.user?.firstName}  ${loginSuccess?.user?.lastName}`}
              </p>
            </div>
            <div onClick={toggleMenu}>
              <ImageTag
                path="/assets/daashboard/user/user.png"
                classes="size-[50px] rounded-full cursor-pointer ml-2"
                altText="logo"
              />
            </div>

            {isOpen && (
              <div className="absolute z-20 right-0 top-14 mt-2 w-48 bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 font-popinsMedium text-sm">
                <ul className="py-2">
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => navigate("/view-profile")}
                  >
                    View Profile
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => navigate("/reset-password")}
                  >
                    Change Password
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => {
                      dispatch(AuthAction.LogoutAction());
                      navigate("/login");
                    }}
                  >
                    Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="h-[85%] flex w-full">
        <div className="w-[25%] h-full">
          <ChatName />
        </div>
        <div className="w-[75%] pl-6 h-full overflow-scroll scrollbar-hide panelScroll">
          {selectedSessionId && <Inbox />}

          {selectedCompletedSessionId && <Inbox />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
